import { createReducer } from '@reduxjs/toolkit'
import { Config } from 'interfaces/api/config.interfaces'

import { getConfig, updateConfig } from './actions'

interface ConfigState {
  items?: Config
  loading: boolean
  loadingSave: boolean
  isSuccess: boolean
}

const initialState: ConfigState = {
  loading: false,
  loadingSave: false,
  isSuccess: false,
}

export const configReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getConfig.fulfilled, (state, { payload }) => {
      state.items = payload
      state.loading = false
    })
    .addCase(getConfig.pending, (state) => {
      state.loading = true
    })
    .addCase(getConfig.rejected, (state) => {
      state.loading = false
    })
    .addCase(updateConfig.pending, (state, { meta }) => {
      state.items = {
        ...state.items,
        ...meta.arg.data,
      }
      state.loadingSave = true
      state.isSuccess = false
    })
    .addCase(updateConfig.rejected, (state) => {
      state.loadingSave = false
      state.isSuccess = false
    })
    .addCase(updateConfig.fulfilled, (state) => {
      state.loadingSave = false
      state.isSuccess = true
    })
})
